import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var timeout = 30 * 1000;
export var SendMessageToServiceWorker = /*#__PURE__*/function () {
  function SendMessageToServiceWorker(log) {
    var _this = this;
    var logTag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    _classCallCheck(this, SendMessageToServiceWorker);
    _defineProperty(this, "messageMap", new Map());
    _defineProperty(this, "initEvent", function () {
      var _navigator$serviceWor;
      (_navigator$serviceWor = navigator.serviceWorker) === null || _navigator$serviceWor === void 0 ? void 0 : _navigator$serviceWor.addEventListener('message', function (event) {
        var message = event.data;
        var desc = _this.messageMap.get(message === null || message === void 0 ? void 0 : message.taskId);
        if (desc) {
          _this.log.info(SendMessageToServiceWorker.TAG, _this.logTag, "sendMessage callback, taskId:".concat(message === null || message === void 0 ? void 0 : message.taskId));
          desc.callback(message);
          clearTimeout(desc.timer);
        }
        _this.messageMap.delete(message === null || message === void 0 ? void 0 : message.taskId);
      });
    });
    this.log = log;
    this.logTag = logTag;
    this.initEvent();
  }
  _createClass(SendMessageToServiceWorker, [{
    key: "sendMessage",
    value: function sendMessage(data, callback) {
      var _navigator$serviceWor2,
        _navigator$serviceWor3,
        _this2 = this;
      var taskId = Date.now();
      this.log.info(SendMessageToServiceWorker.TAG, this.logTag, "sendMessage, taskId:".concat(taskId, " data: "), data);
      (_navigator$serviceWor2 = navigator.serviceWorker) === null || _navigator$serviceWor2 === void 0 ? void 0 : (_navigator$serviceWor3 = _navigator$serviceWor2.controller) === null || _navigator$serviceWor3 === void 0 ? void 0 : _navigator$serviceWor3.postMessage(_objectSpread(_objectSpread({}, data), {}, {
        taskId: taskId
      }));

      // 需要做超时兜底
      var timer = setTimeout(function () {
        var _desc$callback;
        _this2.log.info(SendMessageToServiceWorker.TAG, _this2.logTag, "sendMessage timeout, taskId:".concat(taskId, " data: "), data);
        clearTimeout(timer);
        var desc = _this2.messageMap.get(taskId);
        desc === null || desc === void 0 ? void 0 : (_desc$callback = desc.callback) === null || _desc$callback === void 0 ? void 0 : _desc$callback.call(desc, {
          result: false
        });
        _this2.messageMap.delete(taskId);
      }, timeout);
      this.messageMap.set(taskId, {
        callback: callback,
        timer: timer,
        data: data
      });
    }
  }]);
  return SendMessageToServiceWorker;
}();
_defineProperty(SendMessageToServiceWorker, "TAG", 'SendMessageToServiceWorker');
//# sourceMappingURL=service-worker.js.map